// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen {
  ul {
    margin: 0;
    list-style-type: none;
    line-height: 0.7;
    margin-bottom: 3px;
    padding-inline-start: 0px;
  }
  ul li {
    display: inline-block;
    list-style: none;
    margin-right: 3px;
    display: inline-block;
    list-style: none;
    color: #aaa;
    font-size: 10px;
    line-height: 10px;
  }
  ul li:after {
    content: "";
    width: 2px;
    height: 2px;
    border-radius: 100%;
    background: var(--ion-color-medium);
    display: inline-block;
    position: relative;
    bottom: 2px;
    margin-left: 4px;
  }
  ul li:last-child:after {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/attribute-list/attribute-list.component.scss"],"names":[],"mappings":"AAIA;EACI;IACI,SAAA;IACA,qBAAA;IACA,gBAAA;IACA,kBAAA;IACA,yBAAA;EAHN;EAKM;IACI,qBAAA;IACA,gBAAA;IACA,iBAAA;IACA,qBAAA;IACA,gBAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;EAHV;EAKU;IACI,WAAA;IACA,UAAA;IACA,WAAA;IAEA,mBAAA;IACA,mCAAA;IACA,qBAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;EAJd;EAQc;IACI,aAAA;EANlB;AACF","sourcesContent":["\r\n// @import \"./theme/mixins.scss\";\r\n// @import \"./theme/dms.variables.scss\";\r\n\r\n@media only screen {\r\n    ul {\r\n        margin: 0;\r\n        list-style-type: none;\r\n        line-height: 0.7;\r\n        margin-bottom: 3px;\r\n        padding-inline-start: 0px;\r\n\r\n        li {\r\n            display: inline-block;\r\n            list-style: none;\r\n            margin-right: 3px;\r\n            display: inline-block;\r\n            list-style: none;\r\n            color: #aaa;\r\n            font-size: 10px;\r\n            line-height: 10px;\r\n\r\n            &:after {\r\n                content: '';\r\n                width: 2px;\r\n                height: 2px;\r\n                // @include border-radius(100%);\r\n                border-radius: 100%;\r\n                background: var(--ion-color-medium);\r\n                display: inline-block;\r\n                position: relative;\r\n                bottom: 2px;\r\n                margin-left: 4px;\r\n            }\r\n\r\n            &:last-child {\r\n                &:after {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
